import AppPage from "../AppPage";
import MenuBottomBar, { MenuBarItem } from "../MenuBottomBar";
import { globals, images } from "../../styles";
import { arrow_Icon, chevron_Icon } from "../../assets/icons";
import { useNavigate } from "../../hooks/useNavigate";
import { Page } from "../../types";
import styles from "./SettingsPage.module.css";

//NOTE TO ELLE: THIS IS JUST A DUMMY PAGE :) NO FUNCTIONALITY FOR MVP NEEDED
function SettingsPage() {
  const { navigate } = useNavigate();

  return (
    <AppPage
      className={globals["page"]}
      bottomBar={
        <MenuBottomBar
          items={[
            MenuBarItem.Home,
            MenuBarItem.News,
            MenuBarItem.Leaderboards,
            MenuBarItem.Groups,
            MenuBarItem.LogOut,
          ]}
        />
      }
    >
      <button
        className={`${globals["button-wrapper"]} ${globals["back-btn--top-left"]}`}
        onClick={() => navigate(Page.Welcome)}
      >
        <div className={globals["back-btn"]}>
          <img src={arrow_Icon} alt="" className={images["back-arrow-icon"]} />
        </div>
      </button>
      <div className={styles["settings-scroll"]}>
        {/* Header */}
        <div className={styles["header"]}>
          <span className={styles["title"]}>Settings</span>
          <span className={styles["dummy-notice"]}>
            This is a dummy page with no funtionality created for the MVP.
          </span>
        </div>

        {/* My Account */}
        <div className={styles["section"]}>
          <span className={styles["section-header"]}>My Account</span>
          <div className={styles["row"]}>
            <span className={styles["row-label"]}>Update Details</span>
            <img src={chevron_Icon} className={images["row-chevron"]} alt="" />
          </div>
          <div className={styles["row"]}>
            <span className={styles["row-label"]}>Account Security</span>
            <img src={chevron_Icon} className={images["row-chevron"]} alt="" />
          </div>
          <div className={styles["row"]}>
            <span className={styles["row-label"]}>Delete Account</span>
            <img src={chevron_Icon} className={images["row-chevron"]} alt="" />
          </div>
        </div>

        {/* Notifications */}
        <div className={styles["section"]}>
          <span className={styles["section-header"]}>Notifications</span>
          <div className={styles["row"]}>
            <span className={styles["row-label"]}>Deadline Reminders</span>
          </div>
          <div className={styles["row"]}>
            <span className={styles["row-label"]}>Breaking News</span>
          </div>
          <div className={styles["row"]}>
            <span className={styles["row-label"]}>My Band News</span>
          </div>
          <div className={styles["row"]}>
            <span className={styles["row-label"]}>Leaderboard Updates</span>
          </div>
        </div>

        {/* Appearance */}
        <div className={styles["section"]}>
          <span className={styles["section-header"]}>Apperance</span>
          <div className={styles["row"]}>
            <span className={styles["row-label"]}>Dark Theme</span>
          </div>
        </div>

        {/* App Tracking */}
        <div className={styles["section"]}>
          <span className={styles["section-header"]}>App Tracking</span>
          <div className={styles["row"]}>
            <span className={styles["row-label"]}>Allow App to Track</span>
          </div>
        </div>
      </div>
    </AppPage>
  );
}

export default SettingsPage;
